module.exports = __webpack_public_path__ + "media/svg/sg-f10f7273.svg";